export default __webpack_public_path__ + "static/media/lock.46dbb090.svg";